import * as React from 'react';
import axios from 'axios';
import * as ReactDOM from 'react-dom';
import {wixAxiosConfig} from '@wix/wix-axios-config';
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n/client-i18n';
import App from './components/App';
import './styles/global.scss';
import {initFullstory} from './utils/fullstory';
import fedopsLogger from './utils/fedops-logger';
import * as MobileDetect from 'mobile-detect';
import {ExperimentsBag} from '@wix/wix-experiments';

const initialI18n = window['__INITIAL_I18N__'];
const baseURL = window['__BASEURL__'];
const staticsBaseUrl = window['__STATICS_BASEURL__'];
const experiments: ExperimentsBag = window['__EXPERIMENTS_DATA__'];

const layoutOrder = window['__LAYOUT_ORDER__'];

initFullstory();
wixAxiosConfig(axios, {baseURL});

ReactDOM.hydrate(
  <I18nextProvider i18n={i18n(initialI18n)}>
    <App
        layoutOrder={layoutOrder}
        staticsBaseUrl={staticsBaseUrl}
        fedopsLogger={fedopsLogger}
        experiments={experiments}
    />
  </I18nextProvider>,
  document.getElementById('root')
);

if (typeof navigator) {
    const md = new MobileDetect(navigator.userAgent);
    const deviceType = (md.tablet() || md.phone()) !== null ? 'phone' : 'desktop';
    const fetchedDevice = document.body.getAttribute('data-device');
    if (fetchedDevice === 'desktop' && fetchedDevice !== deviceType) {
      document.body.setAttribute('data-device', deviceType);
    }
}
